import axios from 'axios';
import { API_URL, getPDFAuthHeader } from '.';
import { BasicSearchRequest } from '../Models/BasicSearchRequest';

class ReportsApi {
  static getPayrollReport(request: BasicSearchRequest) {
    return axios.post(
      `${API_URL}/api/reports/payroll/`,
      request,
      getPDFAuthHeader()
    );
  }
}

export default ReportsApi;
